module.exports = __webpack_public_path__ + "static/img/b10.ccb7ef4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b10.jpg
// module id = a5Ep
// module chunks = 1